<template>
    <div>
        <div class="text-xl font-bold uppercase mb-4">
            {{ $t('COLORS_PRINTING') }}
            <span>&mdash; {{ selectedMethodTitle }}</span>
        </div>

        <button
            v-for="method in availableMethods" :key="method.type"
            :class="[
                'flex w-full',
                {
                    'cz2__printing-option--selected': method.selected,
                }
            ]" :disabled="!method.available"
            @click.prevent="selectMethod(method)">

            <div :class="['cz2__printing-option__icon mr-4', 'cz2__printing-option__icon--' + method.type]"></div>
            <div class="flex flex-col items-start text-left">
                <div class="text-sm font-bold">{{ method.name }}</div>
                <div class="text-xs">{{ method.notes }}</div>
            </div>
        </button>
    </div>
</template>

<style lang="scss">
@import "../../style/variables.scss";

.cz2__printing-option__icon--etching {
    width: $icon-size;
    height: $icon-size;
    background: transparent url(../../assets/color-etch@2x.png) no-repeat center/contain;
}

.cz2__printing-option__icon--printing {
    width: $icon-size;
    height: $icon-size;
    background: transparent url(../../assets/color-print@2x.png) no-repeat center/contain;
}

.cz2__printing-option--selected {
    .cz2__printing-option__icon {
        position: relative;

        &:after {
            content: '';

            display: block;
            position: absolute;

            width: $icon-size;
            height: $icon-size;

            border-radius: $icon-size;

            border: 2px solid #000;
        }
    }
}
</style>

<script>
    import { mapState } from 'vuex';
    import { showEtchingConfirmationModal, showPrintingConfirmationModal } from '../../utilities/UI/modals';

    export default {
        props: {
            availableMethods: {
                type: Array,
                required: true,
            },
        },
        computed: {
            ...mapState({
                selectedPersonalizationMethod: (state) => state.customizer.personalizationMethod,
            }),
            selectedMethodTitle() {
                if (this.selectedPersonalizationMethod === 'etching') {
                    return this.$t('PRINTING_ETCHING');
                }

                if (this.selectedPersonalizationMethod === 'printing') {
                    return this.$t('PRINTING_PRINTING');
                }

                return '';
            },
        },
        methods: {
            selectMethod(method) {
                if (this.selectedPersonalizationMethod === method.type) { return; }
                if (method.type === 'printing') {
                    showPrintingConfirmationModal({
                        callback: method.type,
                        showGenericConfirm: this.showGenericConfirm,
                    });
                } else {
                    showEtchingConfirmationModal({
                        callback: method.type,
                        showGenericConfirm: this.showGenericConfirm,
                    });
                }
            },
        },
    };
</script>